__turbopack_context__.v({
  "button": "FocusAreaFilter-module-scss-module__ajWQ2a__button",
  "focusAreasList": "FocusAreaFilter-module-scss-module__ajWQ2a__focusAreasList",
  "root": "FocusAreaFilter-module-scss-module__ajWQ2a__root",
});
